import { commander } from "./singletons.js"

export function set_effect_stack(effect_id, value)
{
    commander.exec_command(
        {
            command_type: "set_effect_stack",
            effect_id: effect_id,
            stack_value: value,
        }
    );
}

export function armor_charge_clicked(index)
{
    let armor_charges = character.get_armor_charges();

    if (index == armor_charges - 1)
    {
        document.getElementById(`armor_charge_button_${index}`).style.backgroundColor = 'transparent';
        character.set_armor_charges(index);
        return;
    }

    for (let i = 0; i <= index; i++)
    {
        document.getElementById(`armor_charge_button_${i}`).style.backgroundColor = '#369eb0';
    }

    for (let i = index + 1; i < armor_charges; i++)
    {
        document.getElementById(`armor_charge_button_${i}`).style.backgroundColor = 'transparent';
    }

    character.set_armor_charges(index + 1);
}

// STATS
export function set_stat(stat_name, new_value)
{
    commander.exec_command(
        {
            command_type: "set_stat",
            stat_id: stat_name,
            stat_value: new_value,
        }
    );
}

export function update_minor_stats(stat_name, stats)
{
    switch (stat_name)
    {
        case 'mobility':
            document.getElementById('Walk Speed').textContent = (stats.walk_speed + 'm/s');
            document.getElementById('Strafe Speed').textContent = stats.strafe_speed + 'm/s';
            document.getElementById('Crouch Speed').textContent = stats.crouch_speed + 'm/s';
            break;
        case 'resilience':
            document.getElementById('Shield Amount').textContent = stats.shield_amount;
            document.getElementById('Health Amount').textContent = stats.health_amount;
            document.getElementById('Flinch Resistance').textContent = stats.flinch_resistance + '%';
            document.getElementById('Resist Against Combatants').textContent = stats.resist_pve + '%';
            break;
        case 'recovery':
            document.getElementById('Health Regen Delay').textContent = stats.health_regen_delay + 's';
            document.getElementById('Shield Regen Delay').textContent = stats.shield_regen_delay + 's';
            document.getElementById('Health Regen Time').textContent = stats.health_regen_time + 's';
            document.getElementById('Shield Regen Time').textContent = stats.shield_regen_time + 's';
            document.getElementById('Health+Shield Regen Time').textContent = stats.health_shield_regen_time + 's';
            document.getElementById('Total Regen Time').textContent = stats.total_regen_time + 's';
            break;
        case 'discipline':
            document.getElementById('Grenade Regeneration Rate').textContent = stats.grenade_ability_basic_regeneration_rate;
            break;
        case 'intellect':
            document.getElementById('Super Regeneration Rate').textContent = stats.super_regeneration_rate;
            break;
        case 'strength':
            document.getElementById('Melee Regeneration Rate').textContent = stats.melee_ability_basic_regeneration_rate;
            break;
    }
}

export function partially_redraw_stat(stat_name, old_value, new_value, element)
{
    if (old_value < new_value)
    {
        for (let i = old_value + 10; i <= new_value; i += 10)
        {
            document.getElementById(stat_name + '_' + i).style.backgroundColor = element_color[element][i / 10];
        }
    }
    else
    {
        for (let i = new_value + 10; i <= old_value; i += 10)
        {
            document.getElementById(stat_name + '_' + i).style.backgroundColor = "grey";
        }
    }
}

// sandbox_switch
export function change_sandbox(sw)
{
    //console.log("gamemode switch_clicked() -> click! " + sw.checked);
    let sandbox_type = "pve"

    if (sw.checked)
    {
        sandbox_type = "pvp";
    }

    document.documentElement.setAttribute('data-gamemode', sandbox_type);
    localStorage.setItem('gamemode', sandbox_type);

    character.set_sandbox(sandbox_type);

    update_all_default_durations(character.sandbox);// TODO: Check what is the problem

    commander.update(
        {
            update_type: "update_activity_select_list",
            sandbox: sandbox_type,
        }
    );

    //experimental
    commander.exec_command(
        {
            command_type: "set_sandbox",
            sandbox: sandbox_type,
        }
    );
}

export function update_percentage(type, value)
{
    //experimental
    commander.exec_command(
        {
           command_type: "set_ability_energy",
           ability_type: type,
           energy_value: value, // number
        }
    );
}

export function effect_duration_change(effect_id, value)
{
    //experimental
    commander.exec_command(
        {
            command_type: "set_effect_duration",
            effect_id: effect_id,
            duration_value: value,
        }
    );
}

export function update_all_default_durations(sandbox)
{
    for (let effect of character.effects.affecting_cooldowns)
    {
        if (effect.type == 'buff')
        {
            if (effect.get_default_duration(sandbox) != null)
            {
                console.log("update duration for:", effect.id, effect.get_default_duration(sandbox))
                effect_duration_change(effect.id, effect.get_default_duration(sandbox));
                document.getElementById(`insight_${effect.id}`).updateDisplayDuration(effect.get_default_duration(sandbox));
                //document.getElementById(`${effect.id}_duration`).value = effect.get_default_duration(sandbox);
            }
        }
    }
}

export function update_armor_charge_duration(duration)
{
    document.getElementById('armor_charge_duration').innerText = '\u00A0(Total duration:\u00A0' + duration + 's)';
}

export function update_armor_charge_capacity(amount)
{
    //console.log(amount);
    for (let i = 0; i < amount; i++)
    {
        document.getElementById(`armor_charge_button_${i}`).style.display = 'block';
    }
    for (let i = amount; i < 7; i++)
    {
        document.getElementById(`armor_charge_button_${i}`).style.display = 'none';
        document.getElementById(`armor_charge_button_${i}`).style.backgroundColor = 'transparent';
    }
}

export function change_activity(self)
{
    //console.log('change_activity', self.value);
    //character.set_activity_type(self.value);

    commander.exec_command(
        {
            command_type: "set_activity",
            activity_id: self.value,
        }
    );
}